// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

<script
      async
      data-environment="production"
      src="https://js.klarna.com/web-sdk/v1/klarna.js"
      data-client-id="klarna_live_client_KVApd0h4ZjNpaFVQMVA4MzdkLyh2bzhHUjkxSHBzLW0sZTIwNzg0YWMtMjBkOS00OThlLWI0YzMtN2NhZWE0ZGY2MGVhLDEsUXo0TEU5MVZ3bTBWZW1wako1NDl3WWFzTk1DNUcxUTNwbm9ZNGJyRGNsOD0"
    ></script>	// Write your Javascript code here using the Velo framework API

	// Print hello world:
	// console.log("Hello world!");

	// Call functions on page elements, e.g.:
	// $w("#button1").label = "Click me!";

	// Click "Run", or Preview your site, to execute your code

});